import type { TFunction } from "i18next";

/**
 * Hisobot nomlari tarjimasi (spec §2.6).
 *
 * ⚠️ **Descriptor matni SERVERDA o'zbekcha qoladi** — u XLSX sarlavhasi
 * uchun ham ishlatiladi. Frontend `reports.json` dagi kalit orqali
 * tarjima qiladi; kalit yo'q bo'lsa (masalan, server yangi hisobot
 * qo'shgan, frontend hali yangilanmagan) SERVER MATNIGA qaytadi —
 * foydalanuvchi xom kalitni ko'rmaydi. Qorovul: `reportI18n.test.ts`
 * har descriptor kind va ustun kaliti uchun `uz` VA `ru` kalitini
 * talab qiladi.
 */
export function reportTitle(t: TFunction, d: { kind: string; title: string }): string {
	return t(`kinds.${d.kind}.title`, { defaultValue: d.title });
}

export function reportDescription(t: TFunction, d: { kind: string; description: string }): string {
	return t(`kinds.${d.kind}.description`, { defaultValue: d.description });
}

/**
 * Ustun sarlavhasi.
 *
 * ⚠️ **Bir kalit — turli hisobotda turli nom.** Descriptorlarda
 * `employeeName` `leads` da «Kim kiritdi», qolganlarida «Xodim»;
 * `zoneName` va `occurredAt` ham shunday. Umumiy `columns.<key>`
 * yolg'iz bo'lsa bu farq jimgina yo'qolardi, shuning uchun ixtiyoriy
 * `kind` berilganda avval `kinds.<kind>.columns.<key>` qidiriladi.
 */
export function columnTitle(
	t: TFunction,
	c: { key: string; title: string },
	kind?: string
): string {
	const umumiy = t(`columns.${c.key}`, { defaultValue: c.title });

	return kind ? t(`kinds.${kind}.columns.${c.key}`, { defaultValue: umumiy }) : umumiy;
}
